module.exports = __webpack_public_path__ + "img/team1.5174306c.png";